// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2Uioz","visuallyhidden":"_1ufcf","hide-text":"tk_Yt","center":"_3IHT3","noprint":"_21_YB","subheading":"_3AY4R","subtitle":"_2RsST"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-subtitle/styles/default.scss
 ** module id = 1019
 ** module chunks = 2
 **/